import { IFormGizmoV2, IGizmo } from '../../types';
import configV2ToV3 from './config-v2-to-v3';

interface IParams {
  config: IFormGizmoV2 | IGizmo;
}

/**
 * Transform a root gizmo config to v3
 *
 * @param {IFormGizmoV2 | IGizmo} config v2 or v3 config, if it has 'fid' it's v3
 *
 * @returns {IGizmo} v3 configuration
 */
function rootGizmoConfigV2ToV3({ config }: IParams): IGizmo {
  if ((config as IGizmo).fid) {
    return config as IGizmo;
  }
  config = config as IFormGizmoV2;

  const rootGizmo: IGizmo = {
    fid: config.id,
    version: config.version,
    type: 'form',
    label: config.title,
    catalogs: config.catalogs,
  };

  if (config.advanced_options) {
    rootGizmo.ops = {
      ...config.advanced_options,
    };

    if (!rootGizmo.ops.form) {
      rootGizmo.ops.form = {};
    }

    if (config.advanced_options.onlineCatalogs !== undefined) {
      rootGizmo.ops.form.onlineCatalogs =
        config.advanced_options.onlineCatalogs;
    }
  }

  if (config.questions) {
    const jumpPresent = config.questions.find(q => q.type === 'jump');
    let currentSection: IGizmo | undefined;
    const gizmos: IGizmo[] = [];

    if (jumpPresent) {
      currentSection = {
        fid: 'g0',
        type: 'section',
        label: 'Section 1',
        uid: 'section_1',
        gizmos: [],
      };

      gizmos.push(currentSection);
    }

    for (const question of config.questions) {
      const gizmo: IGizmo = configV2ToV3({
        config: question,
        questions: config.questions,
      });

      if (question.type === 'jump') {
        if (
          gizmo.ops?.section?.jumps &&
          Array.isArray(gizmo.ops.section.jumps) &&
          gizmo.ops.section.jumps.length > 0 &&
          currentSection
        ) {
          currentSection.ops = {
            section: {
              jumps: gizmo.ops.section.jumps,
            },
          };

          gizmo.ops.section.jumps = [];
        }

        // Since there is a jump we add a new section
        currentSection = gizmo;

        gizmos.push(gizmo);
      } else {
        if (currentSection?.gizmos) {
          currentSection.gizmos.push(gizmo);
        } else {
          gizmos.push(gizmo);
        }
      }
    }

    for (const gizmo of gizmos) {
      if (
        gizmo.ops?.section?.jumps &&
        Array.isArray(gizmo.ops.section.jumps) &&
        gizmo.ops.section.jumps.length > 0
      ) {
        for (const jump of gizmo.ops.section.jumps) {
          for (const sectionGizmo of gizmos) {
            const g = sectionGizmo.gizmos?.find(
              g => g.fid === jump.destinyGizmoFid
            );

            if (g) {
              jump.destinyFid = sectionGizmo.fid;
              jump.destinyUid = sectionGizmo.uid;
            }
          }
        }
      }
    }

    rootGizmo.gizmos = gizmos;
  }

  if (config.status) {
    rootGizmo.status = config.status;
  }

  return rootGizmo;
}

export default rootGizmoConfigV2ToV3;
